import { useCallback, useMemo } from 'react';
import { useModal } from '../contexts/ModalContext';

/**
 * Drop-in replacement for window.alert(), rendered with the product Dialog.
 * alert(message, { title, isError, buttonLabel }) returns a promise that resolves on OK.
 */
export function useAlert() {
    const { showAlert } = useModal();

    // Messages are rendered as text (never HTML); keep only printable content.
    const clean = (message) => (typeof message === 'string' ? message : String(message ?? ''));

    const alert = useCallback((message, options = {}) => {
        const { title = 'Notice', isError = false, buttonLabel = 'OK' } = options;
        return showAlert({ title: clean(title), message: clean(message), buttonLabel, isError });
    }, [showAlert]);

    return useMemo(() => ({
        alert,
        alertSuccess: (message, title = 'Done') => alert(message, { title, isError: false }),
        alertError: (message, title = 'Something went wrong') => alert(message, { title, isError: true }),
        alertInfo: (message, title = 'Information') => alert(message, { title, isError: false }),
    }), [alert]);
}
